import { IconType } from 'react-icons';
import { 
  SiSpringboot, 
  SiKotlin, 
  SiReact, 
  SiTypescript,
  SiJavascript,
  SiNextdotjs,
  SiAmazonaws,
  SiDocker,
  SiJenkins,
  SiApachekafka,
  SiRedis,
  SiMysql,
  SiMariadb,
  SiPostgresql,
  SiGit,
  SiJira,
  SiKubernetes,
  SiOracle
} from 'react-icons/si';
import { FaDatabase, FaJava, FaGlobe, FaServer, FaCloud } from 'react-icons/fa';

// 기술 이름을 아이콘에 매핑
const techIconMap: Record<string, IconType> = {
  'Spring Boot': SiSpringboot,
  'Spring Security': SiSpringboot,
  'Java': FaJava,
  'Kotlin': SiKotlin,
  'JPA': FaDatabase,
  'WebFlux': SiSpringboot,
  'JavaScript': SiJavascript,
  'React': SiReact,
  'TypeScript': SiTypescript,
  'Next.js': SiNextdotjs,
  'JSP': FaJava,
  'AWS EC2': SiAmazonaws,
  'AWS RDS': SiAmazonaws,
  'AWS S3': SiAmazonaws,
  'AWS IoT Core': SiAmazonaws,
  'AWS Load Balancer': SiAmazonaws,
  'AWS CloudWatch': SiAmazonaws,
  'AWS Auto Scaling': SiAmazonaws,
  'AWS Route53': SiAmazonaws,
  'Route53': SiAmazonaws,
  'CloudWatch': SiAmazonaws,
  'Auto Scaling': SiAmazonaws,
  'Load Balancer': SiAmazonaws,
  'ElastiCache': SiAmazonaws,
  'Beanstalk': SiAmazonaws,
  'CloudFront': SiAmazonaws,
  'MySQL': SiMysql,
  'MariaDB': SiMariadb,
  'PostgreSQL': SiPostgresql,
  'Redis': SiRedis,
  'Redis Pub/Sub': SiRedis,
  'Redis Streams': SiRedis,
  'Kafka': SiApachekafka,
  'Docker': SiDocker,
  'Kubernetes': SiKubernetes,
  'Jenkins': SiJenkins,
  'Git': SiGit,
  'Jira': SiJira,
  'WebSocket': FaGlobe,
  'SSE': FaServer,
  'MQTT': FaCloud,
  'PostGIS': SiPostgresql,
  'GIS': FaGlobe,
  'REST API': FaServer,
  'Master-Slave DB': FaDatabase,
  'AOP': SiSpringboot,
  'Payment API': FaServer,
  'Reactive Programming': SiSpringboot,
  'Geospatial Data': FaGlobe,
  'Oracle': SiOracle,
};

// 기술 이름에서 아이콘 찾기
export const getTechIcon = (techName: string): IconType | null => {
  // 정확한 매칭 시도
  if (techIconMap[techName]) {
    return techIconMap[techName];
  }
  
  // 부분 매칭 시도
  const lowerTechName = techName.toLowerCase();
  for (const [key, icon] of Object.entries(techIconMap)) {
    if (lowerTechName.includes(key.toLowerCase()) || key.toLowerCase().includes(lowerTechName)) {
      return icon;
    }
  }
  
  // AWS 관련
  if (lowerTechName.includes('aws')) {
    return SiAmazonaws;
  }
  
  // 기본 아이콘 (데이터베이스)
  if (lowerTechName.includes('db') || lowerTechName.includes('database') || lowerTechName.includes('sql')) {
    return FaDatabase;
  }
  
  return null;
};
